import axios from "axios";
import { apiURL } from "utils/config";
import { getAuthorizationHeaders } from "./auth";
import store from "../store";

const url = (id) => `${apiURL}/school/${id}/dashboard/birthdays`;

/**
 * Returns BirthDays for contracts
 * @returns {AxiosPromise}
 */

export const getBirthdays = () => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: url(schoolId),
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};
